import { Component, OnInit } from '@angular/core';
import { UiTable } from "../../../../../components/ui/table/table.component";
import { TableModePassationMarche } from '../../../../../data/schemas/table.schema';
import { routeAlias } from '../../../../../../routesalias';
import { RouterLink } from "@angular/router";
import { ModePassationMarcheRes } from '../../../../../data/http/responses/modepassationmarche.res';
import { AppService } from '../../../../../core/app.service';
import { ModePassationMarcheService } from '../../../../../services/modepassation.service';
import { UiButtonComponent } from '../../../../../components/button/button.component';
import { loaderIntervantion } from '../../../../../components/ui/loaderIntervantion/loaderIntervantion.component';
import { ConfirmDialogComponent } from '../../../../../components/ui/Confirmdialog/Confirmdialog.component';

@Component({
  selector: 'app-modepassationmarche',
  standalone: true,
  imports: [UiTable, RouterLink, UiButtonComponent, loaderIntervantion, ConfirmDialogComponent],
  templateUrl: './modepassationmarche.component.html',
  styleUrl: './modepassationmarche.component.css'
})
export class ModepassationmarchePage implements OnInit {
  public tableMode = TableModePassationMarche;
  public routeAlias = routeAlias;
  public modePassationMarches: ModePassationMarcheRes[] = [];
  public isLoading: boolean = false;

  // Confirmation suppression
  public showDeleteConfirm: boolean = false;
  public selectedItem: ModePassationMarcheRes | null = null;
  public deleteLoading: boolean = false;

  constructor(
    private modePassationMarcheService: ModePassationMarcheService,
    private appService: AppService
  ) {}

  ngOnInit(): void {
    this.loadModePassationMarche();
  }

  loadModePassationMarche(): void {
    const appId = this.appService.getAppId();
    if (!appId) return;
    this.isLoading = true;
    this.modePassationMarcheService.getAllByAppId(appId).subscribe({
      next: (response: any) => {
        this.modePassationMarches = response.data;
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Erreur chargement :', error);
        this.isLoading = false;
      }
    });
  }

  openDeleteConfirm(item: ModePassationMarcheRes): void {
    this.selectedItem = item;
    this.showDeleteConfirm = true;
  }

  cancelDelete(): void {
    this.showDeleteConfirm = false;
    this.selectedItem = null;
  }

  confirmDelete(): void {
    if (!this.selectedItem) return;
    this.deleteLoading = true;
    this.modePassationMarcheService.delete(this.selectedItem.id).subscribe({
      next: () => {
        this.loadModePassationMarche();
        this.deleteLoading = false;
        this.cancelDelete();
      },
      error: (error) => {
        console.error('Erreur suppression :', error);
        this.deleteLoading = false;
      }
    });
  }
}